<template>
    <div v-if="data && items.length">
        <div
            v-for="componentName in activeComponents"
            :key="componentName"
        >
            <component
                :is="componentName"
                :checkout-data="data"
                :component-name="componentName"
                :current-component="currentComponent"
                :current-step="currentStep"
                :scroll-top-offset="scrollTopOffset"
                :scroll-duration="scrollDuration"
            />
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { without } from 'lodash-es'
import api from '../../api/checkout'

export default {
    props: {
        currentStep: {
            type: Number,
            default: () => {
                return 1
            }
        },
        scrollTopOffset: {
            type: Number,
            default: () => {
                return 150
            }
        },
        scrollDuration: {
            type: Number,
            default: () => {
                return 500
            }
        },
        components: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            activeComponents: this.components,
            data: null
        }
    },

    computed: {
        ...mapState('cart', [
            'items',
            'shippable',
            'price'
        ]),
        currentComponentIndex() {
            return this.currentStep - 1
        },
        currentComponent() {
            return this.activeComponents[this.currentComponentIndex]
        },
        totalPrice() {
            return this.price.gross + (this.data ? this.data.shippingCost : 0)
        },
    },

    watch: {
        shippable() {
            this.updateComponents()
        },
        totalPrice() {
            this.updateComponents()
        }
    },

    created() {
        this.load()

        this.$bus.$on('shipping-mode-saved', shippingMode => {
            const userData = Object.assign(
                {},
                this.data.userData,
                { 'shipping_mode': shippingMode }
            )

            this.data = Object.assign(
                {},
                this.data,
                { userData }
            )
        })
    },

    methods: {
        async load() {
            try {
                const response = await api.checkoutData()

                this.data = response.data

                this.updateComponents()

                this.$bus.$emit('checkout-data-loaded', this.data)
            } catch (error) {
                this.$bus.$emit('checkout-error', error)
            }
        },

        updateComponents() {
            const hiddenComponents = []

            if (! this.shippable) {
                hiddenComponents.push('shipping-mode')
            }

            if (this.data && this.data.isAuthenticated) {
                hiddenComponents.push('authentication')
            }

            if (this.totalPrice <= 0) {
                hiddenComponents.push('payment-mode')
            }

            this.activeComponents = hiddenComponents.length
                ? without(this.components, ...hiddenComponents)
                : this.components

            this.$bus.$emit('update-active-components', this.activeComponents)
        },
    }
}
</script>
